var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useEffect, useState } from "react";
import Button from "../../Ui/Button";
import { useForm } from "react-hook-form"; //https://react-hook-form.com/get-started
import { DateLimitStyled, InmediatePaymentStyled, InputSalesStyled, MultipleDateLimitStyled, PaymentFormStyled, RefCycleStyled, RefEpaycoStyled, RefInfoStyled, TitlePaymentStyled, } from "./style";
import InputLayout from "../../InputLayout";
import CheckBox from "../../Ui/CheckBox";
import InputPayment from "../../InputPayment";
import ButtonBack from "../../ButtonBack";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { getInvoiceClear } from "../../../redux/actions/invoiceActions";
import ExitModal from "../../Modals/ExitModal";
import WarningMessage from "../../WarningMessage/index";
import PaymentServices from "../../../services/paymentServices";
import ErrorModal from "../../Modals/ErrorModal";
import { formatDate, formatNumber } from "../../../utils/helpers";
import moment from "moment";
import ToolTip from "../../Tooltip";
import config from "../../../config/enviroment";
var dataBack = {};
var dataPayment = {};
var PaymentForm = function () {
    var navigate = useNavigate();
    var paymentServices = new PaymentServices();
    var dispatch = useDispatch();
    var _a = useState(false), isLoading = _a[0], setisLoading = _a[1];
    var _b = useState(true), immediatePayment = _b[0], setImmediatePayment = _b[1];
    var _c = useState(false), showExitModal = _c[0], setShowExitModal = _c[1];
    var _d = useState(false), isBonus = _d[0], setIsBonus = _d[1];
    var _e = useState(false), ShowErrorModal = _e[0], setShowErrorModal = _e[1];
    var invoice = useSelector(function (state) { return state.invoice; });
    var _f = useState("none"), tooltipActive = _f[0], setTooltipActive = _f[1];
    var _g = useState("1"), unselected = _g[0], setUnselected = _g[1];
    var infoInvoices = [];
    var countSalesInvoices = 0;
    if (invoice.elements) {
        for (var index = 0; index < invoice.elements; index++) {
            infoInvoices.push(invoice[index]);
            infoInvoices[index].position = index;
            if (infoInvoices[index].extra10 == "SALES-INV") {
                countSalesInvoices = countSalesInvoices + 1;
            }
        }
        if (infoInvoices.length > 0) {
            if (!infoInvoices.find(function (el) { return el.active; })) {
                infoInvoices[0].active = true;
            }
        }
    }
    else {
        infoInvoices.push(invoice);
        infoInvoices[0].active = immediatePayment;
        if (invoice.extra10 == "SALES-INV") {
            countSalesInvoices = countSalesInvoices + 1;
        }
        else {
            countSalesInvoices = 0;
        }
    }
    var _h = useForm({ mode: "onChange" }), register = _h.register, handleSubmit = _h.handleSubmit, watch = _h.watch, reset = _h.reset, errors = _h.formState.errors, setValue = _h.setValue;
    useEffect(function () {
        if (invoice.elements > 0) {
            for (var index = 0; index < invoice.length; index++) {
                if (!invoice[index].total)
                    navigate("/");
                if (invoice[index].total == 0)
                    setImmediatePayment(false);
            }
        }
        else {
            if (invoice.total == 0)
                setImmediatePayment(false);
        }
    }, []);
    //escucha el cambio de valor del input para validar el monto
    useEffect(function () {
        var valueInput = watch("payment");
        var total = invoice.total;
        total && setIsBonus(parseInt(valueInput, 10) > total);
    }, [watch("payment")]);
    var invoiceSelected = function (data) {
        if (data.extra10 == "CYCLE-INV" && countSalesInvoices != 0) {
            setTooltipActive("block");
        }
        else {
            for (var index = 0; index < invoice.elements; index++) {
                infoInvoices[index].active = false;
            }
            if (data.extra10 != "CYCLE-INV" && countSalesInvoices != 0) {
                infoInvoices[data.position].active = true;
            }
            dataBack.channel = "Web";
            dataBack.currency = data.moneda ? data.moneda : infoInvoices[0].currency;
            dataBack.date = data.extra4 ? data.extra4 : infoInvoices[0].date;
            dataBack.isLoading = false;
            dataBack.id = data.id;
            dataBack.parameter = "";
            dataBack.ref = data.extra11 ? data.extra11 : infoInvoices[0].ref;
            dataBack.total = data.total;
            dataBack.value = data.extra1 ? data.extra1 : infoInvoices[0].value;
            dataPayment = data;
            dataBack.typeInvoice = data.extra10 ? data.extra10 : "";
        }
    };
    var onSubmit = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var dataSend, paymentSent, dataRefPago;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dataSend = {};
                    paymentSent = 0;
                    if (dataBack.total) {
                        dataSend = dataBack;
                        paymentSent = dataBack.total;
                        dataRefPago = {
                            refPago: dataBack.ref,
                            balance: dataBack.total,
                        };
                        sessionStorage.setItem("dataRefPago", JSON.stringify(dataRefPago));
                        localStorage.setItem("typeInvoice", dataBack.typeInvoice ? dataBack.typeInvoice : "CYCLE-INV");
                    }
                    else {
                        localStorage.setItem("typeInvoice", infoInvoices[0].extra10 || "CYCLE-INV");
                        dataBack.channel = infoInvoices[0].channel
                            ? infoInvoices[0].channel
                            : "Web";
                        dataBack.currency = infoInvoices[0].currency
                            ? infoInvoices[0].currency
                            : infoInvoices[0].moneda;
                        dataBack.date = infoInvoices[0].date
                            ? infoInvoices[0].date
                            : infoInvoices[0].extra8;
                        dataBack.isLoading = false;
                        dataBack.id = infoInvoices[0].id;
                        dataBack.parameter = infoInvoices[0].parameter || "";
                        dataBack.ref = infoInvoices[0].ref
                            ? infoInvoices[0].ref
                            : infoInvoices[0].extra11;
                        dataBack.total = infoInvoices[0].total;
                        dataBack.value = infoInvoices[0].value
                            ? infoInvoices[0].value
                            : infoInvoices[0].extra1;
                        dataPayment = infoInvoices[0];
                        dataBack.typeInvoice = infoInvoices[0].extra10
                            ? infoInvoices[0].extra10
                            : "";
                        dataSend = dataBack;
                        paymentSent = infoInvoices[0].total;
                    }
                    if (countSalesInvoices == 0 && !immediatePayment) {
                        paymentSent = data.payment;
                    }
                    setisLoading(true);
                    return [4 /*yield*/, paymentServices.openCheckout(dataSend, function () { return navigate("/pago"); }, paymentSent)];
                case 1:
                    _a.sent();
                    setisLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var onSubmitImmediatePayment = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, error_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setisLoading(true);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 4, , 5]);
                    _a = invoice.total;
                    if (!_a) return [3 /*break*/, 3];
                    return [4 /*yield*/, paymentServices.openCheckout(invoice, function () { return navigate("/pago"); }, invoice.total.toString())];
                case 2:
                    _a = (_b.sent());
                    _b.label = 3;
                case 3:
                    _a;
                    return [3 /*break*/, 5];
                case 4:
                    error_1 = _b.sent();
                    setShowErrorModal(true);
                    return [3 /*break*/, 5];
                case 5:
                    setisLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    //para volver al inicio
    var actionBack = function () {
        dispatch(getInvoiceClear({
            isLoading: false,
        }));
        navigate("/");
    };
    //valida el estado inicial de boton para que esté desactivado
    var validateRefOrNumber = function () {
        var valueInput = watch("payment");
        if (!immediatePayment && valueInput == undefined)
            return true;
        if (immediatePayment && valueInput == "")
            return false;
        if (valueInput == "")
            return true;
        return errors.payment != null;
    };
    var compareDates = function (date) {
        var dateNow = moment();
        var dateLimit = moment(date);
        return dateNow.isAfter(dateLimit);
    };
    var cancelEventDefault = function (e) {
        e.preventDefault();
    };
    var onClickTotalPayment = function () {
        if (!immediatePayment) {
            if (typeof invoice.total === "number" && invoice.total != 0)
                setImmediatePayment(!immediatePayment);
        }
    };
    var onClickPayment = function () {
        if (immediatePayment) {
            setImmediatePayment(!immediatePayment);
        }
    };
    var validateNumber = function (e) {
        var valueInput = watch("payment");
        var regex = /^[0-9]+$/;
        if (!regex.test(valueInput)) {
            setValue("payment", valueInput.substring(0, valueInput.length - 1));
        }
    };
    var tooltipClose = function () {
        setTooltipActive("none");
    };
    validateRefOrNumber();
    return (React.createElement(React.Fragment, null,
        ShowErrorModal && (React.createElement(ErrorModal, { type: "opps", onClick: function () {
                immediatePayment
                    ? onSubmitImmediatePayment
                    : handleSubmit(onSubmit);
            }, onExit: function () {
                setShowErrorModal(false);
            } })),
        React.createElement(ButtonBack, { onClick: function () { return setShowExitModal(true); } }),
        React.createElement(PaymentFormStyled, null,
            showExitModal && (React.createElement(ExitModal, { onClick: function () { return actionBack(); }, onExit: function () { return setShowExitModal(false); } })),
            countSalesInvoices != 0 ? (React.createElement(React.Fragment, null,
                React.createElement("div", { className: "alertInfo" }, "Tu pago ser\u00E1 aplicado en l\u00EDnea. Recuerda que en caso de que tu servicio se haya inhabilitado por mora, una vez realizado el pago se restablecer\u00E1 en m\u00E1ximo una hora."))) : (React.createElement(React.Fragment, null)),
            React.createElement("div", { className: "headerDetail" },
                React.createElement("div", { className: "paymentTitle" }, "\u00A1Paga f\u00E1cil y seguro!"),
                countSalesInvoices == 0 ? (React.createElement(React.Fragment, null,
                    React.createElement(RefCycleStyled, null,
                        React.createElement("p", null,
                            React.createElement("span", null, infoInvoices[0].value && infoInvoices[0].value.length > 10
                                ? "N°. ref:"
                                : "N° línea:"),
                            " ",
                            infoInvoices[0].value
                                ? infoInvoices[0].value
                                : infoInvoices[0].extra11)))) : (React.createElement(React.Fragment, null,
                    React.createElement(RefInfoStyled, null,
                        React.createElement("p", null,
                            React.createElement("span", null, infoInvoices[0].value && infoInvoices[0].value.length > 10
                                ? "N°. ref:"
                                : "N° línea:"),
                            " ",
                            infoInvoices[0].value
                                ? infoInvoices[0].value
                                : infoInvoices[0].extra11)))),
                compareDates(infoInvoices[0].date || "") &&
                    countSalesInvoices == 0 ? (React.createElement(TitlePaymentStyled, null,
                    React.createElement("p", null, "PAGO INMEDIATO"))) : (typeof infoInvoices[0].total === "number" &&
                    infoInvoices[0].total != 0 &&
                    countSalesInvoices == 0 && (React.createElement(DateLimitStyled, null,
                    "Fecha l\u00EDmite de pago:",
                    " ",
                    React.createElement("span", null, formatDate(infoInvoices[0].date || "", "DD-MMM-YYYY")))))),
            React.createElement("form", { onSubmit: handleSubmit(onSubmit) },
                React.createElement("div", { className: countSalesInvoices == 0 ? "mensualInvoice" : "invoice-container" }, infoInvoices.map(function (x) {
                    var active = "";
                    var dateLimit = "";
                    if (x.extra10 == "CYCLE-INV" && countSalesInvoices != 0) {
                        active = "inputDisabled";
                    }
                    if (infoInvoices[0].date) {
                        dateLimit = infoInvoices[0].date;
                    }
                    else {
                        dateLimit = infoInvoices[x.position].extra8;
                    }
                    return (React.createElement("div", null,
                        x.extra10 == "CYCLE-INV" ? (React.createElement(React.Fragment, null,
                            React.createElement(ToolTip, { style: { display: tooltipActive }, onClick: tooltipClose }, "Para pagar la factura mensual se requiere primero pagar las facturas de venta."))) : (React.createElement(React.Fragment, null)),
                        React.createElement("div", { className: active, style: { borderRadius: "10px" } },
                            countSalesInvoices == 0 ? (React.createElement(React.Fragment, null,
                                React.createElement(InputLayout, { style: { border: "none" } },
                                    React.createElement("input", __assign({ type: "hidden" }, register("payment", {}), { value: dataPayment })),
                                    React.createElement(CheckBox, { immediatePayment: x.active, setImmediatePayment: function () {
                                            invoiceSelected(x);
                                            setImmediatePayment(!immediatePayment);
                                        } }),
                                    React.createElement("span", { className: "pointer ".concat(immediatePayment), onClick: function () {
                                            invoiceSelected(x);
                                            setImmediatePayment(!immediatePayment);
                                        } },
                                        x.extra10 == "SALES-INV" ? (React.createElement(React.Fragment, null, "Factura de venta")) : (React.createElement(React.Fragment, null)),
                                        x.extra10 == "CYCLE-INV" || !x.extra10 ? (React.createElement(React.Fragment, null, "Factura mensual")) : (React.createElement(React.Fragment, null))),
                                    React.createElement("p", { onClick: onClickTotalPayment, className: "amount pointer ".concat(immediatePayment), style: { opacity: x.active ? "1" : "0.3" } },
                                        "$ ",
                                        formatNumber(x.total || 0))))) : (React.createElement(React.Fragment, null,
                                React.createElement(InputSalesStyled, null,
                                    React.createElement("input", __assign({ type: "hidden" }, register("payment", {}), { value: dataPayment })),
                                    React.createElement(CheckBox, { immediatePayment: x.active, setImmediatePayment: function () {
                                            invoiceSelected(x);
                                            setImmediatePayment(!immediatePayment);
                                        } }),
                                    React.createElement("span", { className: "pointer ".concat(immediatePayment), onClick: function () {
                                            invoiceSelected(x);
                                            setImmediatePayment(!immediatePayment);
                                        } },
                                        x.extra10 == "SALES-INV" ? (React.createElement(React.Fragment, null, "Factura de venta")) : (React.createElement(React.Fragment, null)),
                                        x.extra10 == "CYCLE-INV" || !x.extra10 ? (React.createElement(React.Fragment, null, "Factura mensual")) : (React.createElement(React.Fragment, null))),
                                    React.createElement("p", { onClick: onClickTotalPayment, className: "amount pointer ".concat(immediatePayment), style: { opacity: x.active ? "1" : "0.3" } },
                                        "$ ",
                                        formatNumber(x.total || 0))))),
                            countSalesInvoices != 0 ? (React.createElement(React.Fragment, null,
                                React.createElement(MultipleDateLimitStyled, null,
                                    React.createElement("div", { className: "dateLimit" }, compareDates(dateLimit || "") ? (React.createElement(InmediatePaymentStyled, null,
                                        React.createElement("p", null, "PAGO INMEDIATO"))) : (typeof infoInvoices[0].total === "number" &&
                                        infoInvoices[0].total != 0 && (React.createElement(DateLimitStyled, null,
                                        "Fecha l\u00EDmite de pago:",
                                        " ",
                                        React.createElement("span", null, formatDate(infoInvoices[0].date
                                            ? infoInvoices[0].date
                                            : infoInvoices[x.position].extra8 || "", "DD-MMM-YYYY"))))))))) : (React.createElement(React.Fragment, null)))));
                })),
                countSalesInvoices == 0 ? (React.createElement(React.Fragment, null,
                    React.createElement("p", { className: "information" },
                        "Tu pago ser\u00E1 aplicado en l\u00EDnea. Recuerda que en caso de que tu servicio se haya inhabilitado por mora, una vez realizado el pago se restablecer\u00E1 en m\u00E1ximo una hora.",
                        " "))) : (React.createElement(React.Fragment, null)),
                countSalesInvoices >= 1 ? (React.createElement(React.Fragment, null)) : (React.createElement(React.Fragment, null,
                    React.createElement(InputLayout, null,
                        React.createElement(CheckBox, { immediatePayment: !immediatePayment, setImmediatePayment: function () {
                                setImmediatePayment(!immediatePayment);
                            } }),
                        React.createElement("span", { className: "pointer passPayment ".concat(!immediatePayment && "focus-24"), onClick: onClickPayment }, "Abonar pago"),
                        React.createElement("div", { className: "pointer", onClick: onClickPayment, style: { flexGrow: 2 } },
                            React.createElement(InputPayment, { className: "".concat(!immediatePayment && errors.payment && "red"), initValue: !immediatePayment },
                                React.createElement("input", __assign({ type: "number", className: "".concat(!immediatePayment && errors.payment && "red") }, register("payment", {
                                    required: true,
                                    minLength: 4,
                                    onChange: function (e) {
                                        validateNumber(e);
                                    },
                                })))))))),
                countSalesInvoices == 0 ? (React.createElement(React.Fragment, null,
                    React.createElement("p", { className: "information right ".concat(!immediatePayment && errors.payment && "red") }, "*Escribe un valor superior a $1,000 COP"))) : (React.createElement(React.Fragment, null)),
                !immediatePayment && isBonus && (React.createElement(WarningMessage, { onClick: function () { return setIsBonus(false); } })),
                React.createElement("div", { className: "button-web-style" },
                    React.createElement("div", { className: "button-container" },
                        React.createElement(Button, { loading: isLoading, disabled: tooltipActive == "block" ? true : validateRefOrNumber(), type: "submit" }, "PAGAR")),
                    React.createElement("div", { className: "hide-mobile button-container" },
                        React.createElement(Button, { line: true, onClick: function () { return setShowExitModal(true); } }, "VOLVER")))),
            React.createElement(RefEpaycoStyled, null,
                React.createElement("img", { className: "icon", src: config.urlS3 + "/wom/icons/union.png", alt: "security" }),
                React.createElement("p", null, "Pagos procesados por"),
                React.createElement("img", { src: config.urlS3 + "/wom/epayco.png", alt: "logo E payco" })))));
};
export default PaymentForm;
